export const formatMinutesToHourMinute = (totalMinutes: number | null | undefined): string | null => {
  if (totalMinutes === null || totalMinutes === undefined) return null;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}:${String(minutes).padStart(2, "0")}`;
};
